import { useMsal } from "@azure/msal-react";
import React, { useCallback, useEffect, useState } from "react";
import { msalConfig } from "../../configs/MSAL.config";
import { InteractionStatus } from "@azure/msal-browser";
import {
  Alert,
  Button,
  Card,
  Col,
  Container,
  Row,
  Spinner,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
import essilorPROLogo from "../../assets/images/EssilorPRO_Logo_rgb.png";

const AuthB2C = () => {
  const { instance, inProgress } = useMsal();
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showDelayHint, setShowDelayHint] = useState(false);

  const startSSORequest = useCallback(async () => {
    setErrorMessage("");
    setIsSubmitting(true);
    setShowDelayHint(false);

    try {
      await instance.initialize();
      await instance.loginRedirect({
        authority: process.env.REACT_APP_MSAL_AUTHORITY,
        scopes: msalConfig.auth.scopes,
        redirectStartPage: "/issue-request",
      });
    } catch (error) {
      console.error("B2C redirect login failed", error);
      setErrorMessage(
        "We could not start secure sign-in. Please try again or continue without login."
      );
      setIsSubmitting(false);
    }
  }, [instance]);

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      startSSORequest();
    }
  }, [inProgress, startSSORequest]);

  useEffect(() => {
    if (!isSubmitting) {
      return undefined;
    }

    const timeout = setTimeout(() => {
      setShowDelayHint(true);
    }, 7000);

    return () => clearTimeout(timeout);
  }, [isSubmitting]);

  return (
    <Container fluid className="mt-20">
      <Row className="justify-content-center">
        <Col md="8" lg="6">
          <Card className="card-stats">
            <Card.Header>
              <Card.Title as="h3">Signing you in</Card.Title>
            </Card.Header>
            <Card.Body className="text-center">
              <Spinner animation="border" role="status" />
              <div className="container-img" >
                <img src={essilorPROLogo} alt="mdo" width="75"/><br/>
              </div>
              <p className="mt-3 mb-2">
                Authenticating with your EssilorPRO® sign-in.
              </p>
              <p className="text-muted">
                This usually takes a few seconds. Do not close this page.
              </p>

              {showDelayHint && !errorMessage && (
                <Alert variant="info" className="text-start">
                  Sign-in is taking longer than expected. You can wait, retry, or
                  continue without login.
                </Alert>
              )}

              {errorMessage && (
                <Alert variant="danger" className="text-start">
                  {errorMessage}
                </Alert>
              )}

              <div className="d-flex justify-content-center gap-2">
                <Button
                  variant="primary"
                  onClick={startSSORequest}
                  disabled={isSubmitting}
                >
                  Try secure sign-in again
                </Button>
                <Button
                  variant="outline-secondary"
                  onClick={() => history.push("/issue-request")}
                >
                  Continue without login
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AuthB2C;
